var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileblob(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 471,
    viewBox: "0 0 500 471",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M337.613 61.6328C395.755 92.6617 465.625 124.134 490.054 173.78C513.995 223.426 492.009 291.247 452.921 347.985C413.834 404.28 357.157 449.494 294.128 465.008C231.099 480.079 161.23 465.008 102.11 438.855C42.9902 412.259 -5.38064 374.581 0.482491 333.357C5.85703 291.69 64.977 246.476 82.5664 200.82C100.156 155.606 75.7261 109.949 86.4751 70.9415C96.7356 32.377 141.686 0.461572 187.614 0.0183018C233.054 -0.868238 279.47 30.6039 337.613 61.6328Z",
    fill: "#DD6F69"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileblob);
export default __webpack_public_path__ + "static/media/profileblob.93b218c279a883a3f7852d4a4bd372fe.svg";
export { ForwardRef as ReactComponent };